<template>
    <v-card>
        <v-card-title primary-title class="font-weight-bold">
            <h3>
                Create Phone Booking
            </h3>
        </v-card-title>
        <v-divider/>
        <v-card-text>
            <v-layout row wrap>
                <v-flex xs6>
                    Choose Passenger
                </v-flex>
                <v-flex xs4>
                    <choose-passenger-multi :multi="false"
                                            v-model="passenger"
                                            return-object
                                            label="Choose Passenger"
                    />
                </v-flex>
                <v-flex xs2 v-if="hasPermission('CREATE_PASSENGERS')">
                    <v-btn color="primary" @click="create_passenger = true">
                        Create Passenger
                    </v-btn>
                </v-flex>
                <template v-if="!!passenger">
                    <v-flex xs6>
                        Enter Pickup Location
                    </v-flex>
                    <v-flex xs6>
                        <choose-pin v-model="pick_up_location"/>
                    </v-flex>
                    <v-flex xs6>
                        Enter Pickup details
                    </v-flex>
                    <v-flex xs6>
                        <v-text-field v-model="pick_up_location_details"/>
                    </v-flex>
                    <v-flex xs6>
                        Enter Pull down Location
                    </v-flex>
                    <v-flex xs6>
                        <choose-pin v-model="pull_down_location"/>
                    </v-flex>
                    <template v-if="!!pick_up_location && !!pick_up_location_details && !!pull_down_location">
                        <v-flex xs6>
                            Service
                        </v-flex>
                        <v-flex xs12>
                            <choose-service-multi :multi="false"
                                                  return-object
                                                  v-model="service"
                                                  :initial-search-params="serviceParams"/>
                        </v-flex>
                        <template v-if="!!service">
                            <v-flex xs6>
                                Choose Date
                            </v-flex>
                            <v-flex xs6>
                                <choose-date v-model="date"/>
                            </v-flex>
                            <v-flex xs6>
                                Choose Time
                            </v-flex>
                            <v-flex xs6>
                                <choose-time v-model="time"/>
                            </v-flex>
                            <template v-if="!!time && !!date">
                                <v-btn :loading="loading" color="primary" @click="save">
                                    Create Phone Booking
                                </v-btn>
                            </template>
                        </template>
                    </template>
                </template>

            </v-layout>
        </v-card-text>
        <v-dialog v-model="create_passenger">
            <create-passenger mini :key="create_passenger" @create="passengerCreated"/>
        </v-dialog>
    </v-card>
</template>

<script>
    import ChoosePassengerMulti from "@/components/wasilni/input/ChoosePassengerMulti";
    import CreatePassenger from "@/components/CreatePassenger";
    import ChoosePin from "@/components/wasilni/input/ChoosePin";
    import ChooseServiceMulti from "@/components/wasilni/input/ChooseServiceMulti";
    import ChooseDate from "@/components/wasilni/input/ChooseDate";
    import ChooseTime from "@/components/wasilni/input/ChooseTime";

    export default {
        name: "create-phone-booking",
        components: {ChooseDate, ChooseServiceMulti, ChoosePassengerMulti, ChooseTime, CreatePassenger, ChoosePin},
        data() {
            return {
                service: null,
                passenger: null,
                pick_up_location: null,
                pull_down_location: null,
                pick_up_location_details: null,
                date: null,
                time: null,
                use_wallet: true,
                create_passenger: false,
                loading: false
            }
        },
        methods: {
            passengerCreated(passenger) {
                passenger.text = passenger.first_name + " " + passenger.last_name + " " + passenger.username;
                this.passenger = passenger;
                this.create_passenger = false;
            },
            save() {
                const data = {
                    passenger_id: this.passenger.id,
                    service_id: this.service.id,
                    voucher: null,
                    pick_up_location: {
                        type: "Point",
                        coordinates: this.pick_up_location
                    },
                    pull_down_location: {
                        type: "Point",
                        coordinates: this.pull_down_location
                    },
                    pick_up_location_details: this.pick_up_location_details,
                    pick_up_voice_recording: null,
                    pull_down_location_details: null,
                    dates: [this.date],
                    time: this.time,
                    seats: 1,
                    use_wallet: this.use_wallet
                };


                this.loading = true;
                this.axios.post(this.api.ACTIONS.BOOKINGS, data)
                    .then(x => {
                        this.$emit("create", x.data.data);
                    })
                    .catch(x => {
                        alert(x.response.data.message);
                    })
                    .finally(
                        () => this.loading = false
                    )
            }
        },
        computed: {
            serviceParams() {
                if (!this.passenger)
                    return new URLSearchParams();
                const params = new URLSearchParams();
                params.append("passenger_id", this.passenger.id);
                if (!this.pick_up_location || !this.pull_down_location)
                    return params;
                params.append("pick_lng", this.pick_up_location[0]);
                params.append("pick_lat", this.pick_up_location[1]);
                params.append("pull_lng", this.pull_down_location[0]);
                params.append("pull_lat", this.pull_down_location[1]);
                return params;
            }
        }
    }
</script>

<style scoped>

</style>